import { combineReducers } from "redux";

const rootReducers = combineReducers({});

export default rootReducers;
